// Rules
import {extend} from 'vee-validate';
import {required, min, max, regex, required_if, email, integer, confirmed} from 'vee-validate/dist/rules';
extend("date", {
  validate: value =>
    /^(19|20)\d\d[/]([1-9]|0[1-9]|1[012])[/]([1-9]|0[1-9]|[12][0-9]|3[01])$/.test(
      value
    ),
  message: "Date must be in YYYY/MM/DD format"
});
extend('confirmed', {
  ...confirmed,
  // message: 'The two {_field_} fields must be same'
});
extend('email', {
  ...email,
  message: 'The field {_field_} must be an email'
});
extend('required', {
  ...required,
  message: 'The field {_field_} is required'
});
extend('min', {
  params: ['length'],
  ...min,
  message: 'The field {_field_} must be at least {length} characters'
});
extend('max', {
  params: ['length'],
  ...max,
  message: 'The field {_field_} may not be greater than {length} characters'
});
extend('regex', {
  ...integer,
  message: 'The field {_field_} does not match requested value'
});
extend('integer', {
  ...integer,
  message: 'The field {_field_} must be an integer'
});
extend('required_if', {
  ...required_if,
  message: 'The field {_field_} is required'
});
